import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { toRef } from 'vue'

import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { useAgentDiscountCodes } from '@/composables/useAgentDiscountCodes'
import { CART_DELAYS, sectionCopy } from '@/config/agentWizardSteps'
import AgentOfferFields from '@/view/ai/AgentOfferFields.vue'
import AgentChooseSection from '@/view/ai/agentWizard/steps/AgentChooseSection.vue'
import AgentMessageField from '@/view/ai/agentWizard/steps/AgentMessageField.vue'
import AgentStoresSection from '@/view/ai/agentWizard/steps/AgentStoresSection.vue'
import { useStoreStepTarget } from '@/view/ai/agentWizard/steps/useStoreStepTarget'


export default {
  __name: 'AgentStepCarts',
  props: { storeId: { type: String, default: null } },
  setup(__props) {

const DELAY_OPTIONS = CART_DELAYS.map(({ key, label }) => ({ name: label, value: key }))

const props = __props

const { wizard, section, subStore, target, showFields } = useStoreStepTarget('carts', toRef(props, 'storeId'))
const codes = useAgentDiscountCodes()

const copy = key => sectionCopy(key, wizard.data, wizard.ctx)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(subStore))
      ? (_openBlock(), _createBlock(AgentChooseSection, {
          key: 0,
          "step-key": "carts"
        }))
      : _createCommentVNode("", true),
    (_unref(section).enabled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(showFields))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(WizardSection, _mergeProps(copy('carts.wait'), { plain: "" }), {
                  default: _withCtx(() => [
                    _createVNode(PillRadioGroup, {
                      modelValue: _unref(target).delay,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(target).delay) = $event)),
                      options: _unref(DELAY_OPTIONS),
                      label: "How long to wait"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('carts.message'))), {
                  default: _withCtx(() => [
                    _createVNode(AgentMessageField, {
                      modelValue: _unref(target).message,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(target).message) = $event)),
                      label: "First text"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('carts.offer'))), {
                  default: _withCtx(() => [
                    _createVNode(AgentOfferFields, {
                      enabled: _unref(target).offer_enabled,
                      "onUpdate:enabled": _cache[2] || (_cache[2] = $event => ((_unref(target).offer_enabled) = $event)),
                      "discount-code-id": _unref(target).discount_code_id,
                      "onUpdate:discountCodeId": _cache[3] || (_cache[3] = $event => ((_unref(target).discount_code_id) = $event)),
                      codes: _unref(codes)
                    }, null, 8, ["enabled", "discount-code-id", "codes"])
                  ]),
                  _: 1
                }, 16)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(AgentStoresSection, {
            "step-key": "carts",
            "sub-step": Boolean(_unref(subStore))
          }, null, 8, ["sub-step"])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

}